/*jshint esversion: 6 */
/*jshint strict: false */

import $ from 'jquery';

function setupEvents() {

    $('.switch input').on('change', function () {
        if ($(this).is(':checked')) {
            $('.comparison').slideUp();
            $('.content-graph').slideUp();
            $('.content-table').slideDown();
        } else {
            $('.content-table').slideUp();
            $('.content-graph').slideDown();
            $('.comparison').slideDown();
        }
    });

    if ($('.switch').is(':visible')) {
        $('.switch input').trigger('change');
    }

    $('.show-homepage').on('click', function(e) {
        e.preventDefault();
        $('main.analysis').hide();
        $('main.homepage').show();
        return false;
    });
}

function init() {
    setupEvents();
}

export {init}


// WEBPACK FOOTER //
// ./analysis.js